define([
  'angular',
  'mod',
], function(angular, mod) {

var m = require('am');

m.directive('joinCode', ['config', '$http', 'throttle', function(config, $http, throttle) {
  var check_code = throttle(function(code, callback) {
    return $http.get('/n/groups/api/join_code/' + code)
      .then(function(response) {
        callback(angular.fromJson(response.data), true);
      })
      .catch(function(response) {
        var message = response.status === 0 ?
          'Network Error' :
          response.data.message
        callback('', false, message);
      });
  }, 1000);

  return {
    require: 'ngModel',
    link: function($scope, $elem, $attrs, ctrl) {
      $scope.$watch(function() {
        return ctrl.$viewValue;
      }, function(code) {
        $scope.class_name = '';
        $scope.join_code_message = '';
        if (!_(ctrl.$error).omit('joinCode').any()) {
          check_code(code, function(data, result, message) {
            $scope.join_code_message = message;
            $scope.class_name = data.name;
            $scope.$parent.clickwrap_required = data.international;
            ctrl.$setValidity('joinCode', result);
          });
        }
      });
    }
  };
}]);

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/directives/joinCode.js
 **/